import { Link, Typography } from '@mui/material'
import { Box } from '@mui/system'
import SupportIcon from '@mui/icons-material/Support'

export function Footer (): JSX.Element {
  const year = new Date().getFullYear()

  return <>
    <Box sx={{ backgroundColor: 'var(--off-white)', position: 'fixed', zIndex: '1201', bottom: '0', display: 'flex', justifyContent: 'center', width: '100%', height: '29px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
        <Typography sx={{ alignContent: 'center' }} variant='body1'>© Copyright {year} Michigan Collaboration Hub at MAISA</Typography>
        <Link
          sx={{
            cursor: 'pointer',
            alignContent: 'center',
            ml: '2em',
            color: 'var(--grey-900)',
            fontWeight: 400
          }}
          onClick={() => {
            window.open('https://servicedesk.oakland.k12.mi.us/servicedesk/customer/portal/19/user/login?destination=portal%2F19%2Fcreate%2F611', '_blank')
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
            <SupportIcon />
            <Typography sx={{ ml: '.5em' }} variant='body1'>Support</Typography>
          </Box>
        </Link>
      </Box>
    </Box>
  </>
}
